import {
  faDhl,
  faFedex,
  faUps,
  faUsps,
} from '@fortawesome/free-brands-svg-icons';
import {
  faArrowLeft,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowsRotate,
  faArrowUpRightFromSquare,
  // investigate using fa file ban
  faBan,
  faBarsFilter,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircleInfo,
  faClipboard,
  faClipboardCheck,
  faClock,
  faCubesStacked,
  faDollarSign,
  faEnvelope,
  faExclamationCircle,
  faLocationDot,
  faMagnifyingGlass,
  faPenToSquare,
  faShieldXmark,
  faTag,
  faTrash,
  faTruck,
  faXmark,
} from '@fortawesome/pro-light-svg-icons';
import {
  faCamera as faCameraSolid,
  faCircleCheck as faCircleCheckSolid,
  faCircleInfo as faCircleInfoSolid,
  faCloudUpload as faCloudUploadSolid,
  faExclamationCircle as faExclamationCircleSolid,
  faExclamationTriangle as faExclamationTriangleSolid,
  faExpand as faExpandSolid,
  faFilePdf as faFilePdfSolid,
  faFile as faFileSolid,
  faFileVideo as faFileVideoSolid,
  faHouse as faHouseSolid,
  faImage as faImageSolid,
  faSparkles as faSparklesSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { match } from 'ts-pattern';

const icons = {
  ArrowLeft: faArrowLeft,
  CameraSolid: faCameraSolid,
  ArrowRight: faArrowRight,
  ArrowRightArrowLeft: faArrowRightArrowLeft,
  ArrowsRotate: faArrowsRotate,
  ArrowUpRightFromSquare: faArrowUpRightFromSquare,
  Check: faCheck,
  CheckCircle: faCheckCircle,
  CheckCircleSolid: faCircleCheckSolid,
  ChevronDown: faChevronDown,
  ChevronLeft: faChevronLeft,
  ChevronRight: faChevronRight,
  ChevronUp: faChevronUp,
  Clipboard: faClipboard,
  ClipboardCheck: faClipboardCheck,
  Clock: faClock,
  CloudUploadSolid: faCloudUploadSolid,
  DHL: faDhl,
  DollarSign: faDollarSign,
  ExclamationCircle: faExclamationCircle,
  ExclamationCircleSolid: faExclamationCircleSolid,
  ExclamationTriangleSolid: faExclamationTriangleSolid,
  Expand: faExpandSolid,
  FedEx: faFedex,
  File: faFileSolid,
  FilePdf: faFilePdfSolid,
  FileVideo: faFileVideoSolid,
  Filter: faBarsFilter,
  House: faHouseSolid,
  ImageSolid: faImageSolid,
  InfoCircle: faCircleInfo,
  InfoCircleSolid: faCircleInfoSolid,
  MagnifyingGlass: faMagnifyingGlass,
  PenToSquare: faPenToSquare,
  SparklesSolid: faSparklesSolid,
  Ban: faBan,
  Tag: faTag,
  Trash: faTrash,
  Truck: faTruck,
  UPS: faUps,
  USPS: faUsps,
  XMark: faXmark,
  ShieldXmark: faShieldXmark,
  Envelope: faEnvelope,
  LocationDot: faLocationDot,
  CubesStacked: faCubesStacked,
} as const;

type IconProps = {
  className?: string;
  icon: keyof typeof icons;
  title?: string;
};

export default function Icon({ className, icon, title }: IconProps) {
  return (
    <FontAwesomeIcon
      icon={icons[icon]}
      className={className}
      aria-label={title}
    />
  );
}

const getCarrierIcon = (carrierName: string) =>
  match(carrierName.toLowerCase())
    .returnType<IconProps['icon']>()
    .with('dhl', () => 'DHL')
    .with('fedex', () => 'FedEx')
    .with('ups', () => 'UPS')
    .with('usps', () => 'USPS')
    .otherwise(() => 'Truck');

export function CarrierIcon({
  carrier,
  className,
}: {
  carrier: string;
  className?: string;
}) {
  return <Icon icon={getCarrierIcon(carrier)} className={className} />;
}
